export default "__VITE_ASSET__D0eh_4cp__"